import { render, staticRenderFns } from "./QuaterlyItem.vue?vue&type=template&id=c71beff8&scoped=true"
import script from "./QuaterlyItem.vue?vue&type=script&setup=true&lang=js"
export * from "./QuaterlyItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./QuaterlyItem.vue?vue&type=style&index=0&id=c71beff8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71beff8",
  null
  
)

export default component.exports